// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { useTheme } from '@mui/material';
import { AxisScale } from '@visx/axis';
import { Interval } from 'luxon';

interface Props {
  /**
   * The date scale used by the timeline.
   */
  scale: AxisScale<number>;

  /**
   * The y-coordinate of the top of the timeline.
   */
  y: number;

  /**
   * The height of the timeline.
   */
  height: number;

  /**
   * The density of the timeline.
   */
  density: 'day' | 'week' | 'month';

  /**
   * The interval of the timeline.
   */
  interval: Interval;
}

/**
 * A group of SVG elements that highlight alternating intervals on a timeline.
 */
export function TimelineColumns(props: Props) {
  const theme = useTheme();

  const scaleIntervals = props.interval.splitBy({ [props.density]: 1 });

  return (
    <g>
      {scaleIntervals.map((interval, index) => {
        const key = interval.toString();
        const start = props.scale(interval.start.toJSDate()) ?? 0;
        const end = props.scale(interval.end.toJSDate()) ?? 0;
        const highlightWidth = end - start;
        const height = props.height - props.y;
        const fill = index % 2 === 0 ? theme.palette.action.hover : 'none';

        return (
          <rect
            key={key}
            x={start}
            y={props.y}
            fill={fill}
            width={highlightWidth}
            height={height}
          />
        );
      })}
    </g>
  );
}
